import { PlayerInit } from './types';

export function createPlayerInit(
	player_id: number,
	user_id: number,
	game_id: number,
	color: string,
	pname: string,
	is_admin: boolean = false
): PlayerInit {
	const username = pname;

	return {
		player_id,
		user_id,
		game_id,
		color,
		pname,
		username,
		is_admin,
	};
}
